import React from "react";
import TasksPage from "./index";

export default function AllTasksPage() {
  return <TasksPage mode="all" />;
}
